import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquareMinus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import api from "../../services/api";
import EditModal from "../ui/EditModal";
import { normalizar } from "../../common/stringNormalizer";

const AddGruposEtarios = () => {
  const [grupos, setGrupos] = useState([]);
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [EdadDesde, setEdadDesde] = useState("");
  const [EdadHasta, setEdadHasta] = useState("");
  const [seleccionado, setSeleccionado] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState(
    () => localStorage.getItem("filtroGruposEtarios") || "activos"
  );

  const cargar = async () => {
    try {
      const { data } = await api.get("/grupos-etarios");
      setGrupos(data);
    } catch {
      Swal.fire("Error", "No se pudieron obtener los grupos etarios.", "error");
    }
  };

  useEffect(() => { cargar(); }, []);
  useEffect(() => { localStorage.setItem("filtroGruposEtarios", filtroEstado); }, [filtroEstado]);

  const validar = (values) => {
    const desde = Number(values.EdadDesde);
    const hasta = Number(values.EdadHasta);
    if (!values.Nombre?.trim()) return "Ingresá el nombre.";
    if (!Number.isInteger(desde) || !Number.isInteger(hasta) || desde < 0 || hasta > 120) {
      return "Las edades deben ser números enteros entre 0 y 120.";
    }
    if (desde > hasta) return "La edad desde no puede ser mayor que la edad hasta.";
    return null;
  };

  const guardar = async (e) => {
    e.preventDefault();
    const values = { Nombre, Descripcion, EdadDesde, EdadHasta };
    const error = validar(values);
    if (error) return Swal.fire("Datos inválidos", error, "warning");
    if (grupos.some((g) => normalizar(g.Nombre) === normalizar(Nombre))) {
      return Swal.fire("Duplicado", "Ya existe un grupo etario con ese nombre.", "warning");
    }
    try {
      await api.post("/grupos-etarios", values);
      setNombre(""); setDescripcion(""); setEdadDesde(""); setEdadHasta("");
      setFiltroEstado("activos");
      await cargar();
      Swal.fire({ icon: "success", title: "Grupo etario guardado", timer: 1500, showConfirmButton: false });
    } catch (errorApi) {
      Swal.fire("Error", errorApi.response?.data?.msg || "No se pudo guardar el grupo etario.", "error");
    }
  };

  const editar = async (values) => {
    const error = validar(values);
    if (error) return Swal.fire("Datos inválidos", error, "warning");
    try {
      await api.put(`/grupos-etarios/${values.IdGrupoEtario}`, values);
      setSeleccionado(null);
      await cargar();
      Swal.fire({ icon: "success", title: "Grupo etario actualizado", timer: 1500, showConfirmButton: false });
    } catch (errorApi) {
      Swal.fire("Error", errorApi.response?.data?.msg || "No se pudo actualizar.", "error");
    }
  };

  const cambiarEstado = async (row) => {
    if (Number(row.Estado) === 1) {
      const result = await Swal.fire({
        icon: "warning", title: "¿Desactivar grupo etario?",
        text: "No podrá desactivarse si está asignado a personas activas.",
        showCancelButton: true, confirmButtonText: "Sí, desactivar", cancelButtonText: "Cancelar"
      });
      if (!result.isConfirmed) return;
    }
    try {
      const { data } = await api.patch(`/grupos-etarios/${row.IdGrupoEtario}/estado`);
      setFiltroEstado(Number(data.Estado) === 1 ? "activos" : "inactivos");
      await cargar();
    } catch (errorApi) {
      Swal.fire("No permitido", errorApi.response?.data?.msg || "No se pudo cambiar el estado.", "warning");
    }
  };

  const data = grupos.filter((g) =>
    filtroEstado === "todos" || (filtroEstado === "activos" ? Number(g.Estado) === 1 : Number(g.Estado) === 0)
  );
  const columns = [
    { name: "Nombre", selector: (r) => r.Nombre, sortable: true },
    { name: "Descripción", selector: (r) => r.Descripcion || "Sin descripción", sortable: true, grow: 2 },
    { name: "Edad desde", selector: (r) => r.EdadDesde, sortable: true, center: true },
    { name: "Edad hasta", selector: (r) => r.EdadHasta, sortable: true, center: true },
    { name: "Editar", cell: (r) => <button className="button is-small is-info" title="Editar" onClick={() => setSeleccionado(r)}><FontAwesomeIcon icon={faPencil} /></button>, button: true },
    { name: "Estado", cell: (r) => <FontAwesomeIcon icon={Number(r.Estado) === 1 ? faSquarePlus : faSquareMinus} style={{ color: Number(r.Estado) === 1 ? "#37ff00" : "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(r)} />, button: true },
  ];
  const editFields = [
    { name: "Nombre", label: "Nombre", type: "text", required: true },
    { name: "Descripcion", label: "Descripción", type: "text" },
    { name: "EdadDesde", label: "Edad desde", type: "number", required: true },
    { name: "EdadHasta", label: "Edad hasta", type: "number", required: true },
  ];

  return <div className="columns mt-5 is-centered"><div style={{ minWidth: "75vw" }}>
    <div className="notification is-primary"><strong>Agregar Grupo Etario</strong></div>
    <form onSubmit={guardar}>
      <div className="field"><label className="label required">Nombre</label><input className="input" value={Nombre} onChange={(e) => setNombre(e.target.value)} required /></div>
      <div className="field"><label className="label">Descripción</label><input className="input" value={Descripcion} onChange={(e) => setDescripcion(e.target.value)} /></div>
      <div className="columns">
        <div className="column"><label className="label required">Edad desde</label><input className="input" type="number" min="0" max="120" value={EdadDesde} onChange={(e) => setEdadDesde(e.target.value)} required /></div>
        <div className="column"><label className="label required">Edad hasta</label><input className="input" type="number" min="0" max="120" value={EdadHasta} onChange={(e) => setEdadHasta(e.target.value)} required /></div>
      </div>
      <button className="button is-success" type="submit">Guardar</button>
    </form>
    <div style={{ display: "flex", gap: 10, margin: "1rem 0" }}>
      {["todos", "activos", "inactivos"].map((estado) => <button key={estado} type="button" onClick={() => setFiltroEstado(estado)} className={`button is-small ${filtroEstado === estado ? "is-primary" : "is-light"}`}>{estado[0].toUpperCase() + estado.slice(1)}</button>)}
    </div>
    <DataTable pagination paginationComponentOptions={{ rowsPerPageText: "Filas por página", rangeSeparatorText: "de" }} columns={columns} data={data} />
    {seleccionado && <EditModal fields={editFields} initialValues={seleccionado} onSubmit={editar} title="Editar Grupo Etario" onClose={() => setSeleccionado(null)} />}
  </div></div>;
};

export default AddGruposEtarios;
